var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.hooks.blockHelperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "@font-face {\n    font-family: '"
    + ((stack1 = __default(require("../../../../../src/utils/handlebars-helpers/font_quote.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"family") : depths[1]),{"name":"font_quote","hash":{},"data":data,"loc":{"start":{"line":3,"column":18},"end":{"line":3,"column":45}}})) != null ? stack1 : "")
    + "';\n    src: local('☺')"
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"sources") : depth0), depth0),{"name":"sources","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":19},"end":{"line":10,"column":16}}})) != null ? stack1 : "")
    + ";\n    "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"weight") : depth0), depth0),{"name":"weight","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":11,"column":47}}})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"style") : depth0), depth0),{"name":"style","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":12,"column":44}}})) != null ? stack1 : "")
    + "\n}\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.hooks.blockHelperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n        "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"otf") : depth0), depth0),{"name":"otf","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":5,"column":61}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"woff2") : depth0), depth0),{"name":"woff2","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":6,"column":62}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"woff") : depth0), depth0),{"name":"woff","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":7,"column":59}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0),{"name":"svg","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":8,"column":56}}})) != null ? stack1 : "")
    + "\n        "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? lookupProperty(depth0,"ttf") : depth0), depth0),{"name":"ttf","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":9,"column":61}}})) != null ? stack1 : "")
    + "\n    ";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ",url("
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"source") : depth0), depth0))
    + ") format('opentype')";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ",url("
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"source") : depth0), depth0))
    + ") format('woff2')";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ",url("
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"source") : depth0), depth0))
    + ") format('woff')";
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ",url("
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"source") : depth0), depth0))
    + ") format('svg')";
},"11":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ",url("
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"source") : depth0), depth0))
    + ") format('truetype')";
},"13":function(container,depth0,helpers,partials,data) {
    return "font-weight: "
    + container.escapeExpression(container.lambda(depth0, depth0))
    + ";";
},"15":function(container,depth0,helpers,partials,data) {
    return "font-style: "
    + container.escapeExpression(container.lambda(depth0, depth0))
    + ";";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"variants") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":14,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});